import {configureStore} from "@reduxjs/toolkit";
import news from '../components/newsList/news_slice'
import {filter} from "./filter";
const stringMiddleware =()=>(next)=>(action)=>{
    if(typeof action ==='string'){
        return next({type:action})
    }
    return next(action)
}

 export const store = configureStore({
    reducer:{news,filter},
    middleware:(getDefaultMiddleware)=>getDefaultMiddleware().concat(stringMiddleware),
    devTools:process.env.NODE_ENV !=="production"
})